export const SET_ITEMS_MUTATION = 'setItems'
export const SET_LOADING_MUTATION = 'setLoading'
export const SET_SELECTED_MUTATION = 'setSelected'
export const ADD_ITEMS_MUTATION = 'addItems'
export const SET_PAGE_MUTATION = 'setPage'
export const SET_END_REACHED = 'setEndReached'
export const UPDATE_ITEM = 'updateItem'
export const CREATE_ITEM = 'createItem'
export const REMOVE_ITEM = 'deleteItem'
export const RESET_ITEMS = 'resetItems'
export const UNSUBSCRIBE_MUTATION = 'unsubscribe'
export const SET_SUBSCRIPTION = 'subcribe'
